import {
  USACertificateNumberField,
  USADocumentTypeField,
  USAExpirationDateField,
  USAStateSelectorField,
} from "@faire/deprecated-retailer-visitor-shared/features/IDV/resellerCertificateFields";
import { IIdOption } from "@faire/deprecated-retailer-visitor-shared/lib/getResellerCertificateFormData";
import { useGetCountryState } from "@faire/deprecated-retailer-visitor-shared/views/SignUp/reseller-cert/__internal__/useGetCountryState";
import { useStrictLocalization } from "@faire/web/common/localization";
import { Column } from "@faire/web/slate/Layout";
import { useField } from "formik";
import React, { useMemo } from "react";
import * as Yup from "yup";

export const USAResellerCertFields: React.FC<{
  trackFieldValue: (field: string, value: string) => void;
}> = ({ trackFieldValue }) => {
  const { isLoading } = useGetCountryState();
  const [{ value: certificate_number }] = useField("certificate_number");
  const [{ value: isExpirationRequired }] = useField("isExpirationRequired");
  const [{ value: isMultiFields }] = useField("isMultiFields");

  const hideExpirationDate = !certificate_number || !isExpirationRequired;

  return (
    <Column gap="4x">
      <USAStateSelectorField
        disabled={isLoading}
        trackChange={trackFieldValue}
      />
      <USADocumentTypeField hidden={!isMultiFields} optional />
      <USACertificateNumberField trackChange={trackFieldValue} optional />
      <USAExpirationDateField
        hidden={hideExpirationDate}
        trackChange={trackFieldValue}
      />
    </Column>
  );
};

export const useUSASchema = () => {
  const { strictLocalize } = useStrictLocalization();

  return useMemo(() => {
    return Yup.object().shape({
      expires_at: Yup.string().when(
        ["isExpirationRequired", "certificate_number", "selectedField"],
        ([isExpirationRequired, certificate_number, selectedField], schema) => {
          if (
            !isExpirationRequired ||
            (!certificate_number &&
              (selectedField as IIdOption)?.id === "certificate_number")
          ) {
            return schema.optional();
          }

          return schema.required(
            strictLocalize({
              id: "Hbj7gP",
              defaultMessage: "Please provide an expiration date",
              description: {
                text: "Error message when the expiration date is missing",
                img: "https://cdn.faire.com/fastly/915082dcf5815b34dbdfbfc9af3b77cbc0cacd03e777d53a822d67e5857c4990.png",
              },
            })
          );
        }
      ),
    });
  }, [strictLocalize]);
};
